import Vue from 'vue';
import * as MUTATIONS from '@/store/constants/mutations.js';
import { clobber } from 'commons/vuex/map/map.js';

export const mutations = {
    [MUTATIONS.SET_WORKSPACE](state, { workspace }) {
        if (!state.workspaces[workspace.uuid]) {
            Vue.set(state.workspaces, workspace.uuid, formatWorkspace(workspace));
        }
        Object.assign(state.workspaces[workspace.uuid], formatWorkspace(workspace));
    },
    [MUTATIONS.ADD_QUEUE_TO_WORKSPACE](state, { workspace_uuid, queue_uuid }) {
        state.workspaces[workspace_uuid].queues.push(queue_uuid);
    },
    [MUTATIONS.ADD_SEARCH_TO_WORKSPACE](state, { workspace_uuid, saved_search_uuid }) {
        state.workspaces[workspace_uuid].saved_searches.push(saved_search_uuid);
    },
    [MUTATIONS.REMOVE_QUEUE_FROM_WORKSPACE](state, { workspace_uuid, queue_uuid }) {
        state.workspaces[workspace_uuid].queues = state.workspaces[workspace_uuid].queues.filter((queue) => queue !== queue_uuid);
    },
    [MUTATIONS.REMOVE_SEARCH_FROM_WORKSPACE](state, { workspace_uuid, saved_search_uuid }) {
        state.workspaces[workspace_uuid].saved_searches = state.workspaces[workspace_uuid].saved_searches.filter((search) => search !== saved_search_uuid);
    },
    [MUTATIONS.SET_WORKSPACE_PROPERTY](state, { key, item }) {
        clobber(state.workspaces[key], item);
    },
    [MUTATIONS.REMOVE_WORKSPACE](state, workspace_uuid) {
        Vue.delete(state.workspaces, workspace_uuid);
    },
};

const formatWorkspace = (workspace) => ({
    uuid: '',
    name: '',
    owner_uuid: '',
    date_created: 0,
    date_updated: 0,
    last_accessed: 0,
    type: 'custom',
    ...workspace,
    saved_searches: workspace.saved_searches.map(({ saved_search_uuid }) => saved_search_uuid), // force components to hydrate the searches from the store,
    queues: workspace.queues.map(({ queue_uuid }) => queue_uuid), // force components to hydrate the queues from the store
});
